module.exports = __webpack_public_path__ + "static/media/riple.0718fce3.svg";